var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgBackArrowCircled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#back-arrow-circled_svg__clip0_10357_3072)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0 28a28 28 0 1128 28A28.03 28.03 0 010 28zm51.333 0A23.333 23.333 0 1028 51.333 23.36 23.36 0 0051.333 28zm-31.299 3.3l11 10.994 3.299-3.3-11-10.994 10.904-10.904-3.3-3.299-10.903 10.904a4.666 4.666 0 000 6.598z",
    fill: "#0094FF"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "back-arrow-circled_svg__clip0_10357_3072"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
export default SvgBackArrowCircled;